(ns frontend.test-ribbon.model)

(def root-path [::state])

(def fake-data-loaded-path [:fake-data-loaded?])
(def fake-data-loaded-full-path (into root-path fake-data-loaded-path))

(def initialized-path [:initialized])
(def initialized-full-path (vec (concat root-path initialized-path)))

(def location-path [:location])
(def location-full-path (vec (concat root-path location-path)))

(def entity-type-path [:entity-type])
(def entity-type-full-path (into root-path entity-type-path))

(def entity-id-path [:entity-id])
(def entity-id-full-path (into root-path entity-id-path))

(def ribbon-id-path [:ribbon-id])
(def ribbon-id-full-path (into root-path ribbon-id-path))

(def tab-id-path [:tab-id])
(def tab-id-full-path (into root-path tab-id-path))
